
export const FETCH_TEAMS_START = "FETCH_TEAMS_START";
export const FETCH_TEAMS_SUCCESS = "FETCH_TEAMS_SUCCESS";
export const FETCH_TEAMS_ERROR = "FETCH_TEAMS_ERROR";

export const ADD_TEAMS_START = "ADD_TEAMS_START";
export const ADD_TEAMS_SUCCESS = "ADD_TEAMS_SUCCESS";
export const ADD_TEAMS_ERROR = "ADD_TEAMS_ERROR";
export const ADD_TEAMS_CLEAR = "ADD_TEAMS_CLEAR";

export const FETCH_MANAGERS_TEAMS_START = "FETCH_MANAGERS_TEAMS_START";
export const FETCH_MANAGERS_TEAMS_SUCCESS = "FETCH_MANAGERS_TEAMS_SUCCESS";
export const FETCH_MANAGERS_TEAMS_ERROR = "FETCH_MANAGERS_TEAMS_ERROR";

export const FETCH_MEMBERS_TEAMS_START = "FETCH_MEMBERS_TEAMS_START";
export const FETCH_MEMBERS_TEAMS_SUCCESS = "FETCH_MEMBERS_TEAMS_SUCCESS";
export const FETCH_MEMBERS_TEAMS_ERROR = "FETCH_MEMBERS_TEAMS_ERROR";

export const EDIT_TEAMS_MEMBERS_START = "EDIT_TEAMS_MEMBERS_START";
export const EDIT_TEAMS_MEMBERS_DONE = "EDIT_TEAMS_MEMBERS_DONE";
export const EDIT_TEAMS_MEMBERS_ERROR = "EDIT_TEAMS_MEMBERS_ERROR";
export const EDIT_TEAMS_MEMBERS_CLEAR = "EDIT_TEAMS_MEMBERS_CLEAR";


export const EDIT_TEAMS_START = "EDIT_TEAMS_START";
export const EDIT_TEAMS_DONE = "EDIT_TEAMS_DONE";
export const EDIT_TEAMS_ERROR = "EDIT_TEAMS_ERROR";
export const EDIT_TEAMS_CLEAR = "EDIT_TEAMS_CLEAR";

export const DELETE_TEAMS_START = "DELETE_TEAMS_START";
export const DELETE_TEAMS_DONE =  "DELETE_TEAMS_DONE";
